import { render, staticRenderFns } from "./MilkTypes.vue?vue&type=template&id=e1fd43c2"
import script from "./MilkTypes.vue?vue&type=script&lang=js"
export * from "./MilkTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports